import { createContext } from 'react';

import { ReportIssueHandlerState } from './report-issue-handler.model';

export const ReportIssueHandlerContext = createContext<ReportIssueHandlerState | undefined>(
  undefined,
);

ReportIssueHandlerContext.displayName = 'ReportIssueHandlerContext';
